import { useRevealOnScroll } from '../../../core/hooks/useRevealOnScroll';

import './styles/Reveal.css';

export default function Reveal({ as = 'div', className = '', children, ...rest }) {
    const Tag = as;
    const { ref, isVisible } = useRevealOnScroll();
    const classes = ['reveal', isVisible ? 'reveal--visible' : '', className].filter(Boolean).join(' ');

    return (
        <Tag ref={ref} className={classes} {...rest}>
            {children}
        </Tag>
    );
}
